import React from 'react';
import './TrendRankCombo.styl';
import {trendTooltip} from 'components/dashboard/coaching-effectiveness/common';
import {Link} from 'react-router';
import buildUrl from 'components/dashboard/buildUrl';
import {PercentChangeIndicator} from 'components/coaching/landing-pages/helpers/PercentChangeIndicator';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import RankWithDelta from 'components/dashboard/coaching-effectiveness/RankWithDelta';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';

export default class TrendRankCombo extends React.PureComponent {
  render() {
    const {trend, rank} = this.props;
    return (
      <div className="trend-rank-combo">
        <GenericTooltip
          positionTop
          tooltip={trendTooltip(trend)}
          delay={TOOLTIP_DELAY}
          closeImmediately>
          <Link to={buildUrl(this.props) + '/team-skills'}>
            <PercentChangeIndicator avg={trend.trend} useArrow={false} />
          </Link>
        </GenericTooltip>
        <RankWithDelta rank={rank.rank} delta={rank.delta} useColor={true} />
      </div>
    );
  }
}
